module.exports = __webpack_public_path__ + "static/media/server.31ca8f64.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/server.svg
// module id = 1546
// module chunks = 0